module.exports = __webpack_public_path__ + "img/Airbnb-Productivity-Time-Management-1.0e0cb844.jpg";